<template>
  <Dialog title="Handlingen vil fjerne deltagelser på disse begivenheder" confirm="Godkend og fortsæt" @close="(value) => $emit('close', value)">
    <template #content>
      <FguTable
        :columns="['name', 'stayEventsCount']"
        :headings="{
          name: 'Begivenhed',
          stayEventsCount: 'Elever',
        }"
        :rows="events"
        :columnClasses="{
          h__stayEventsCount: 'justify-end',
          stayEventsCount: 'justify-end',
        }"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";
import FguTable from "~/components/fgu-table/FguTable";

export default {
  components: { Dialog, FguTable },

  props: {
    events: {
      type: Array,
      required: true,
    },
  },

  emits: ["close"],
};
</script>
